var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Composant_77_28",
    "data-name": "Composant 77 \\u2013 28",
    transform: "translate(10 10) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    "data-name": "Rectangle 1719",
    width: 10,
    height: 10,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygone_149",
    "data-name": "Polygone 149",
    d: "M3,0,6,4H0Z",
    transform: "translate(2 3)",
    fill: "#4d4f5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e5b91b54df448bcbbdc3e21a715a486b.svg";
export { ForwardRef as ReactComponent };